var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTxnRequestProcessing = function SvgTxnRequestProcessing(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#407bff;}.cls-15,.cls-22,.cls-23,.cls-27,.cls-3,.cls-38,.cls-40,.cls-5{fill:#fff;}.cls-3{opacity:0.9;}.cls-4{fill:#ffc3d0;}.cls-6{fill:#f5d79b;}.cls-7{fill:#f5f5f5;}.cls-13,.cls-8{fill:#d2dbfe;}.cls-26,.cls-40,.cls-8{opacity:0.7;}.cls-17,.cls-9{fill:#263238;}.cls-10,.cls-22{opacity:0.6;}.cls-11{fill:#d5ad95;}.cls-12{fill:#e0e0e0;}.cls-14{fill:#7a88ff;}.cls-15,.cls-17,.cls-33{opacity:0.2;}.cls-16{fill:#ffc3bd;}.cls-18{fill:#c99;}.cls-19{fill:#ebebeb;}.cls-20{fill:#fafafa;}.cls-20,.cls-27,.cls-30{opacity:0.5;}.cls-21{fill:#e6e6e6;}.cls-23,.cls-31{opacity:0.4;}.cls-24{fill:#4c65ba;}.cls-25,.cls-38{opacity:0.3;}.cls-28{fill:#ff8b7b;}.cls-29{mix-blend-mode:multiply;}.cls-29,.cls-32{opacity:0.1;}.cls-34{fill:#ff5652;}.cls-35,.cls-36,.cls-48,.cls-49{fill:none;}.cls-35,.cls-36{stroke:#407bff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-36{stroke-dasharray:0 4.96;}.cls-37{fill:#a0a7fc;}.cls-39{fill:#1a2e35;}.cls-41{fill:#e2e5f8;}.cls-42{fill:#b1ddf4;}.cls-43{fill:#7fa4fb;}.cls-44{fill:#f4f4ff;}.cls-45{fill:#9dc44d;}.cls-46{font-size:3.65px;font-family:Poppins-SemiBold, Poppins;font-weight:600;}.cls-46,.cls-47{fill:#363636;}.cls-48{stroke:#363636;}.cls-48,.cls-49{stroke-miterlimit:10;stroke-width:0.5px;}.cls-49{stroke:#697fe1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    "data-name": "Background Simple"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.7,180.88C92,142.45,61.47,89.79,107.07,63.07,168,27.38,216.59,93.83,270.23,100.72c41,5.27,101.23-75.09,156.21-35.06s-21.13,112.48-19.87,150.2c1.24,37.32,78,93.54,27.13,139.32-49.87,44.9-120.42-21.32-173.56-29-47.14-6.79-151.37,64.2-191.07,11.32C31.45,287.44,89.41,218,90.7,180.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.7,180.88C92,142.45,61.47,89.79,107.07,63.07,168,27.38,216.59,93.83,270.23,100.72c41,5.27,101.23-75.09,156.21-35.06s-21.13,112.48-19.87,150.2c1.24,37.32,78,93.54,27.13,139.32-49.87,44.9-120.42-21.32-173.56-29-47.14-6.79-151.37,64.2-191.07,11.32C31.45,287.44,89.41,218,90.7,180.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 373.62,
    y: 302.49,
    width: 64.94,
    height: 42.3,
    rx: 6.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M438.56,337l5.86,11.07a2.08,2.08,0,0,1-2.69,2.88l-14.1-6.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 381.33,
    y: 309.8,
    width: 49.51,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 381.33,
    y: 314.14,
    width: 24.75,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 381.33,
    y: 322.82,
    width: 39.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 381.33,
    y: 327.16,
    width: 49.51,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 381.33,
    y: 331.5,
    width: 49.51,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 381.33,
    y: 335.84,
    width: 16.47,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 331.75,
    y: 254.51,
    width: 64.94,
    height: 35.68,
    rx: 6.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M331.75,282.47l-5.86,11.08a2.08,2.08,0,0,0,2.69,2.88l14.1-6.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 339.62,
    y: 261.1,
    width: 29.58,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 339.62,
    y: 265.44,
    width: 49.51,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 339.62,
    y: 269.78,
    width: 49.51,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 339.62,
    y: 274.12,
    width: 40.06,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 339.62,
    y: 278.46,
    width: 49.51,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 339.62,
    y: 282.8,
    width: 18.36,
    height: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-7",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character_2",
    "data-name": "Character 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 320.97,
    y: 87.34,
    width: 109.27,
    height: 96.74,
    rx: 8.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 320.97,
    y: 87.34,
    width: 109.27,
    height: 96.74,
    rx: 8.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M382.32,110.33s-2.31,20.17,5.22,21.74c9.4,2,7.12-15.94,7.12-15.94l-7.12-10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M382.32,110.33s-2.31,20.17,5.22,21.74c9.4,2,7.12-15.94,7.12-15.94l-7.12-10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M405.74,115.29s11.42,8.13,6.54,14.56-13-2.65-13.14-7.71S405.74,115.29,405.74,115.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M371.25,164.31l-6.89.66s-7.95-3.26-10.55-2.49C352,163,349.48,167,350,168.8c.19.66,1.77,1.19,2.46,1.25.89.08,2.54-2,3.44-2.05,1.21-.1,3.54,1.91,4.75,1.94a32.11,32.11,0,0,0,4.28-.67l8.12.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M368.46,164.05l1.64,5.89s11.88,1.61,16.55-.43,1.14-36.52-3.35-36.14-2,19.45-2,25.44C381.28,163.39,368.46,164.05,368.46,164.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M368.46,164.05l1.64,5.89s11.88,1.61,16.55-.43,1.14-36.52-3.35-36.14-2,19.45-2,25.44C381.28,163.39,368.46,164.05,368.46,164.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M382.41,133.42c-4.5,6.43,5.85,16.54,6.06,50.66h33.39c1-9.21,4.42-45.34-.39-52.16C415.94,124.1,386.7,127.28,382.41,133.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M382.41,133.42c-4.5,6.43,5.85,16.54,6.06,50.66h33.39c1-9.21,4.42-45.34-.39-52.16C415.94,124.1,386.7,127.28,382.41,133.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M392.27,124.36l6.7-7.27c.64,5.58,3.61,10.15,4.21,10.34l-.73,2.55c-8.12,9.13-10,.37-10,.37C394.43,128.69,392.27,124.36,392.27,124.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M402.06,113.78a6,6,0,0,1-1.68,4c-1.38,1.41-3,.35-3.33-1.52-.33-1.69,0-4.44,1.77-5.15S402.08,111.91,402.06,113.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M394.47,165.46l-6.89.66s-7.79-3.92-10.55-3.55c-1.78.24-5.2,4.5-4.88,6.26.12.68,1.78,1.1,2.45,1.26,1.1.26,4.5-2,4.5-2s3.48,2.84,4.75,3a20.69,20.69,0,0,0,4.28-.66l8.12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M419.78,131.36c-2.21-1.51-4.58,0-7,13.76-2.85,16.38-4.74,17.12-21.12,20.07l1.78,5.89s14,1.73,20.74-2.67S425.76,135.44,419.78,131.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M419.78,131.36c-2.21-1.51-4.58,0-7,13.76-2.85,16.38-4.74,17.12-21.12,20.07l1.78,5.89s14,1.73,20.74-2.67S425.76,135.44,419.78,131.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M395.84,135.1c5.44-.12,10.34-6.62,7.66-7.77a60.66,60.66,0,0,0-10.7,1.33C391.22,129.86,390.22,135.22,395.84,135.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M396.29,120l3.12-.31s-.13,9.36-6.54,10.16c1.19-1.89-.6-5.49-.6-5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M398.06,109.08c1.45,6.62,2.64,10.4.35,14.78a8.81,8.81,0,0,1-15.59.18c-3-5.38-4.91-15.3.64-19.9a8.91,8.91,0,0,1,14.6,4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M388.84,114c.16.53,0,1-.35,1.12s-.74-.22-.89-.75,0-1,.36-1.12S388.7,113.52,388.84,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M382.94,116c.16.52,0,1-.36,1.12s-.73-.23-.89-.76,0-1,.36-1.12S382.79,115.41,382.94,116Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M390.12,111.52a.35.35,0,0,0,.14-.06.32.32,0,0,0-.05-.45h0a3.13,3.13,0,0,0-2.89-.52.32.32,0,0,0-.19.41h0a.31.31,0,0,0,.41.19h0a2.51,2.51,0,0,1,2.26.4A.27.27,0,0,0,390.12,111.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M379.82,114.71a.28.28,0,0,0,.18-.24,2.74,2.74,0,0,1,1.34-2,.32.32,0,0,0,.09-.45.34.34,0,0,0-.36-.13h0a3.33,3.33,0,0,0-1.69,2.44.31.31,0,0,0,.26.37h0A.22.22,0,0,0,379.82,114.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M389.25,122.2a4.83,4.83,0,0,1-.82.41.18.18,0,0,1-.24-.09h0a.2.2,0,0,1,.11-.24,4.94,4.94,0,0,0,3-3.29.18.18,0,0,1,.21-.15.19.19,0,0,1,.15.22A5.07,5.07,0,0,1,389.25,122.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M385,115.61a20.83,20.83,0,0,1-1.11,5,.3.3,0,0,0,.18.38,3.42,3.42,0,0,0,2.36-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M382.15,115.18l-1.5,0S381.7,116.07,382.15,115.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M388,113.32l-1.5,0S387.5,114.18,388,113.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M391.56,104.29s-2.4,8.28-13.78,7.26c0,0-3.62-13,10.55-13.14,0,0,11.17-4.87,14.29,7.33,0,0,9.87,11.35.56,15.38C396.26,124.12,391.56,104.29,391.56,104.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M388.77,170.82H335.52a1.46,1.46,0,1,0,0,2.91h53.25a1.46,1.46,0,1,0,0-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M336.31,172.84h18.2a.69.69,0,0,0,.65-.92l-10-28.51a2,2,0,0,0-1.85-1.32h-18.2a.69.69,0,0,0-.65.92l10,28.52A2,2,0,0,0,336.31,172.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M335.43,172.84h18.2a.69.69,0,0,0,.65-.92l-10-28.51a2,2,0,0,0-1.85-1.32h-18.2a.69.69,0,0,0-.65.92l10,28.52A2,2,0,0,0,335.43,172.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M338.5,159.41h2.3a.09.09,0,0,0,.08-.12l-1.26-3.6a.25.25,0,0,0-.23-.17h-2.31a.09.09,0,0,0-.08.12l1.26,3.6A.26.26,0,0,0,338.5,159.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M356.85,173.73a1.46,1.46,0,0,1,0-2.91h31.92a1.46,1.46,0,1,1,0,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.89,173.78H321v1.76a8.43,8.43,0,0,0,.45,2.72h75.47a2.24,2.24,0,1,0,0-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.51,184.08H394.8v-5.82H321.42A8.55,8.55,0,0,0,329.51,184.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M396.89,173.78H321v1.76a8.43,8.43,0,0,0,.45,2.72h75.47a2.24,2.24,0,1,0,0-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M329.51,184.08H394.8v-5.82H321.42A8.55,8.55,0,0,0,329.51,184.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character_1",
    "data-name": "Character 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.26,338.82H99.5a11.94,11.94,0,0,1-11.84-10.94l-2.14-27.13L90,300.4l2.14,27.13a7.44,7.44,0,0,0,7.38,6.81h11.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M105.32,303.65a5.15,5.15,0,0,0,4.59-5.64l-3.56-34.73a5.13,5.13,0,0,0-5.63-4.58h-34a3.42,3.42,0,0,0-3.06,3.76l3.9,38.12a3.43,3.43,0,0,0,3.76,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M105.32,303.65a5.15,5.15,0,0,0,4.59-5.64l-3.56-34.73a5.13,5.13,0,0,0-5.63-4.58h-34a3.42,3.42,0,0,0-3.06,3.76l3.9,38.12a3.43,3.43,0,0,0,3.76,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M67.55,300.58l-3.9-38.12a3.42,3.42,0,0,1,3.06-3.76h0a5.13,5.13,0,0,1,5.63,4.58L75.9,298a5.15,5.15,0,0,1-4.59,5.64h0A3.43,3.43,0,0,1,67.55,300.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M106,404.57l.3-.92a2.88,2.88,0,0,1,2.74-2h31.8a2.89,2.89,0,0,1,2.82,2.26l.08.37a2.79,2.79,0,0,0,2.73,2.19h0a2.79,2.79,0,0,0,2.73-3.4l-.08-.36a8.48,8.48,0,0,0-8.28-6.66h-31.8a8.48,8.48,0,0,0-8,5.82l-.31.93a2.8,2.8,0,0,0,2.66,3.67h0A2.8,2.8,0,0,0,106,404.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 119.79,
    y: 396.07,
    width: 9.84,
    height: 5.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M124.71,405.86h0a2.8,2.8,0,0,1-2.8-2.8V328.72h5.59v74.34A2.8,2.8,0,0,1,124.71,405.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M128.62,410.93a3.92,3.92,0,1,1-3.91-3.91A3.92,3.92,0,0,1,128.62,410.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M104.48,410.93a3.92,3.92,0,1,1-3.92-3.91A3.93,3.93,0,0,1,104.48,410.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M153.2,410.93a3.92,3.92,0,1,1-3.91-3.91A3.92,3.92,0,0,1,153.2,410.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 121.91,
    y: 333.05,
    width: 5.59,
    height: 13.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M142.86,339.42H106a6.61,6.61,0,0,1-6.44-5.18l-1.1-5H151l-1.86,5.64A6.6,6.6,0,0,1,142.86,339.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M142.86,339.42H106a6.61,6.61,0,0,1-6.44-5.18l-1.1-5H151l-1.86,5.64A6.6,6.6,0,0,1,142.86,339.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M97.3,324.19h54.81a4.59,4.59,0,0,1,4.59,4.59v1.31a3.06,3.06,0,0,1-3.06,3.06H95.78a3.06,3.06,0,0,1-3.06-3.06v-1.31A4.59,4.59,0,0,1,97.3,324.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M163.38,302.1s23-1.15,24.66,6.53-1.84,98-1.84,98l-7.25.45s-12.55-72.36-6.38-84.76l-18.29.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M187.58,366c-4.49-.05-9.53.06-14.49.27.51,4.44,1.07,8.85,1.64,13a109.39,109.39,0,0,0,12.53-3.15C187.37,372.89,187.47,369.48,187.58,366Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M188,406.35a.19.19,0,0,1-.16-.14.18.18,0,0,1,.08-.2c.11-.08,2.75-1.85,4.09-1.58a1,1,0,0,1,.62.39.71.71,0,0,1,.07.81,3.32,3.32,0,0,1-2.27.77A13.16,13.16,0,0,1,188,406.35Zm.59-.29c1.48.07,3.46-.08,3.79-.62,0-.07.09-.18-.07-.41a.48.48,0,0,0-.38-.23,1.45,1.45,0,0,0-.36,0A8.5,8.5,0,0,0,188.54,406.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M187.85,406.35a.18.18,0,0,1-.09-.16c0-.1.06-2.24,1-3.14a1.38,1.38,0,0,1,1-.39c.51,0,.69.26.73.47.23.88-1.54,2.72-2.45,3.2a.11.11,0,0,1-.08,0Zm1.83-3.33a.94.94,0,0,0-.63.28,4.39,4.39,0,0,0-.87,2.49c.93-.65,2.08-2.07,2-2.6,0-.05,0-.18-.39-.19l-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M187.07,405.31l-8.59.62a.69.69,0,0,0-.64.59l-1.05,7.1a1.15,1.15,0,0,0,1,1.32,1,1,0,0,0,.25,0c3.09-.28,5.84-.65,9.69-.92,4.55-.33,3.44.3,8.8,0,3.22-.19,3.55-3.9,2.17-4-6.32-.33-7.1-2.18-9.68-4.24A2.75,2.75,0,0,0,187.07,405.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M149.37,302.84s23.06,1.1,24.32,8.86-7.7,95.48-7.7,95.48l-7.27.1s-9.05-72.88-2.29-85l-18.28-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M168.69,379.71c.41-4.28.84-8.82,1.27-13.45-5.5,0-10.85,0-15.12.11.32,4.88.71,9.71,1.11,14.26C158.56,380.58,163.16,380.38,168.69,379.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M167.59,407.07a.19.19,0,0,1-.15-.15.18.18,0,0,1,.08-.19c.12-.08,2.83-1.73,4.15-1.41a1,1,0,0,1,.61.42.71.71,0,0,1,0,.81,3.4,3.4,0,0,1-2.31.67A14,14,0,0,1,167.59,407.07Zm.6-.27c1.48.14,3.46.07,3.82-.46.05-.06.09-.18,0-.41a.56.56,0,0,0-.38-.25,1.46,1.46,0,0,0-.36,0A8.72,8.72,0,0,0,168.19,406.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M167.49,407.07a.19.19,0,0,1-.08-.17c0-.1.15-2.24,1.13-3.09a1.38,1.38,0,0,1,1-.35c.51,0,.68.29.71.5.19.88-1.65,2.65-2.58,3.1a.11.11,0,0,1-.08,0Zm2-3.26a1,1,0,0,0-.63.26,4.41,4.41,0,0,0-1,2.45c1-.61,2.16-2,2.1-2.52,0-.05,0-.18-.38-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M166.75,406l-8.61.27a.69.69,0,0,0-.66.56l-1.34,7.05a1.15,1.15,0,0,0,.91,1.36,1,1,0,0,0,.24,0c3.1-.15,5.86-.4,9.72-.52,4.57-.13,3.43.45,8.79.36,3.23-.06,3.71-3.75,2.34-3.89-6.3-.59-7-2.47-9.5-4.64A2.78,2.78,0,0,0,166.75,406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M99.36,286.52a51.4,51.4,0,0,1-2.22,8.35c-2.94,8.43-3.6,22,2.34,26.87,9.36,7.64,45.43-1.09,50.66,4.53,4.36,4.69,2,49.13,2,49.13a379.48,379.48,0,0,0,38.75-3.63s-2-11.6-1.12-33.85,3.06-34.18-10.46-35.71-37.62-6.14-40.61-10.74c-2-3.09-1.07-4.86-1.07-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M179.44,373.31c-.84-4-1.87-13.89-.41-37.38.94-15.12,4.12-31.1-9-31.1a9,9,0,0,1,7.21,9.1c0,6.76-3.56,48.54-4.56,60.07C174.88,373.8,177.14,373.57,179.44,373.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M138.51,291.09c-1.7-2.85-.84-4.48-.84-4.48l-38.31-.09a48.71,48.71,0,0,1-1.54,6.27c4.94.43,15.17,1.13,21.52.78,8.89-.48,20.47,2.5,20.47,2.5S135.71,293.05,138.51,291.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M151.69,210.64s-5,15.82-3.22,25.27c1.44,7.56-9.05-5.26-13.33-9.69S148.47,210,148.47,210Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M151.16,215.76s-4.64,9.7-2.85,19.15c1.44,7.56-9.42.86-13.7-3.57s13.33-16.24,13.33-16.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M152.77,274.5l5.37,1.45s7.17-4,9.67-3.46c1.37.31,3.43,2.58,4.93,4.42a2,2,0,0,1-1.06,3.15h0a1.86,1.86,0,0,1-1,0L167,279s-4.11,1.83-5.73,1.93c-2.84.18-10.64-2-10.64-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.42,231c2.29.36,6.78,2.83,1.93,23.12-.76,3.21-2.12,9.31-1.07,12.44,1.89,5.65,12.15,8.18,12.15,8.18l-1.16,5.75s-19-4.08-20.91-10.69C132.49,263.42,133.2,229.42,143.42,231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M143.42,231c2.29.36,6.78,2.83,1.93,23.12-.76,3.21-2.12,9.31-1.07,12.44,1.89,5.65,12.15,8.18,12.15,8.18l-1.16,5.75s-19-4.08-20.91-10.69C132.49,263.42,133.2,229.42,143.42,231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.12,288.38a150.27,150.27,0,0,0,40,0s-1.41-8.52,1.33-22.68c.34-1.73,3.13-12,3.63-13.69,5.4-18.18,8.38-22.79-16.39-24.56-21.29-1.51-24.53,3.82-25.08,16.4S98.12,288.38,98.12,288.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M98.12,288.38a150.27,150.27,0,0,0,40,0s-1.41-8.52,1.33-22.68c.34-1.73,3.13-12,3.63-13.69,5.4-18.18,8.38-22.79-16.39-24.56-21.29-1.51-24.53,3.82-25.08,16.4S98.12,288.38,98.12,288.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M120.37,274l5.44,2.39s7.25-4.07,9.79-3.5c1.62.37,4.68,4.73,4.68,4.73a1.76,1.76,0,0,1-.83,3h0a1.76,1.76,0,0,1-.91,0l-3.78-1.08s-4.17,1.85-5.81,1.95c-2.87.19-10.77-2.93-10.77-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.37,226.63c-3,.78-4.75,2.89-3.6,10.92a2.89,2.89,0,0,1,4.69,0c2.42,2.81,6.75,7.42,6.75,7.42a64.25,64.25,0,0,0,6-6.2c2.3-2.89,3.66.47,3.66.47s1.93-9-2.83-11C133.68,226.42,127,225.69,123.37,226.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.37,226.63c-3,.78-4.75,2.89-3.6,10.92a2.89,2.89,0,0,1,4.69,0c2.42,2.81,6.75,7.42,6.75,7.42a64.25,64.25,0,0,0,6-6.2c2.3-2.89,3.66.47,3.66.47s1.93-9-2.83-11C133.68,226.42,127,225.69,123.37,226.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M101.6,243.85c-.31,7-1.34,19.91-2.21,30,41,16.51,15.14-2.21,15.14-2.21s-8.21-5.6-4.36-19,2.68-21.78,2.68-21.78l-1.31-2.84C103.63,230,102,235.2,101.6,243.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.4,228.79c5.32-.28,7,1.87-.84,21.25-1.25,3.09-3.27,9.42-2.21,12.59,1.92,5.72,18.8,12.52,18.8,12.52l-2.47,5.73S94.5,271.5,95.19,264.79,100.67,229.26,109.4,228.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M109.4,228.79c5.32-.28,7,1.87-.84,21.25-1.25,3.09-3.27,9.42-2.21,12.59,1.92,5.72,18.8,12.52,18.8,12.52l-2.47,5.73S94.5,271.5,95.19,264.79,100.67,229.26,109.4,228.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M131.61,242.77s10.87-9.33,6.72-13c-2.09-1.86-8.53-3.54-14.19-2.24C122.78,227.83,121.54,231.83,131.61,242.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M138.25,233.24a14,14,0,0,0-.36-3c-1-.51-2.73-2.4-.86-5.36L131,214.27c-1.14,4.82-2.13,12.58-6.58,14.13,0,0-1.4,3.65,5,11.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M131,214.27c-.38,1.61-.75,3.55-1.23,5.48a10.5,10.5,0,0,0,7,9.52c-.66-.93-1-2.41.24-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M129.75,205.14c-1.31,8.18-2,11.6,1.11,16.65,4.74,7.6,15.07,7.41,18.8-.2,3.35-6.86,4.94-19.12-2.26-24.05a11.3,11.3,0,0,0-17.65,7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M142.84,211.52c-.2.65,0,1.28.39,1.41s.93-.28,1.13-.92,0-1.27-.39-1.41S143.06,210.93,142.84,211.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M150.08,213.83c-.21.66,0,1.28.39,1.41s.93-.28,1.13-.92,0-1.27-.39-1.4S150.28,213.2,150.08,213.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M151,212.9l1.68,0S151.52,213.9,151,212.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M147.47,214.29a18.07,18.07,0,0,0,1,4.82,2.93,2.93,0,0,1-2.43-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M141.76,220.22a5.67,5.67,0,0,0,.92.36.19.19,0,0,0,.25-.11h0a.2.2,0,0,0-.14-.25,5.33,5.33,0,0,1-3.51-3.3.2.2,0,0,0-.38.11A5.5,5.5,0,0,0,141.76,220.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M140.38,209.14a.39.39,0,0,0,.46-.07,4.68,4.68,0,0,1,3.62-.94.41.41,0,0,0,.47-.33.4.4,0,0,0-.32-.45h0a5.38,5.38,0,0,0-4.33,1.17.39.39,0,0,0,0,.55h0A.17.17,0,0,0,140.38,209.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M153.31,211.18a.41.41,0,0,0,.4,0,.39.39,0,0,0,.12-.55,3.86,3.86,0,0,0-3.13-1.87.37.37,0,0,0-.39.36v0a.38.38,0,0,0,.39.39h0a3.17,3.17,0,0,1,2.43,1.5A.4.4,0,0,0,153.31,211.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M143.74,210.64l1.68,0S144.27,211.6,143.74,210.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M129,208.84s4.56,5.89,7,.62,6-4.64,4.18-7.7c0,0,9.74-.35,12.21,3.43a.49.49,0,0,0,.91-.3c-.25-3.53-1.64-10.49-8.7-10.22,0,0-7.39-5.5-13.71-1.12C124.85,197.71,129,208.84,129,208.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M142.55,194.49s-10.86-7.27-17.85,6.24S104.85,234.16,111,242.18s17.5,6.21,17.56,1.89,1.43-25.38,3.27-31.24S142.55,194.49,142.55,194.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M126.17,210.85a5.93,5.93,0,0,0,2.2,4c1.65,1.27,3.26,0,3.47-2,.17-1.78-.47-4.59-2.43-5.12a2.68,2.68,0,0,0-3.24,3.14Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 191.6,
    y1: 262.95,
    x2: 191.6,
    y2: 262.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M196.4,264.14c8.69,1.8,27.65,4,44-6C267,242,268.82,201,305.75,183.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 308.02,
    y1: 182.48,
    x2: 308.02,
    y2: 182.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M339.39,171.09l-41.05-3.24a1.11,1.11,0,0,0-.75,2l8.48,6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M309.86,180.29l3.43,9.43a2.56,2.56,0,0,0,4.11,1l22-19.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "306.07 176.08 301.98 185.89 309.86 180.29 339.39 171.09 306.07 176.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "310.72 182.67 301.98 185.89 309.86 180.29 310.72 182.67"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M286.85,225.86l-9.52,22a.61.61,0,0,1-.28.29h0a.4.4,0,0,1-.37,0l-34.08-14.76a.51.51,0,0,1-.23-.68l9.52-22a.51.51,0,0,1,.66-.29l34.07,14.76a.51.51,0,0,1,.24.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M286.88,225.49c-1.72.61-19.86,6.65-23.5,7.85a.75.75,0,0,1-.91-.39c-1.61-3.48-9.61-20.84-10.33-22.52.94,1.46,9.1,16.44,11.31,20.37a.75.75,0,0,0,.83.36c4.39-1.08,20.89-5.37,22.6-5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M277.05,248.12h0L270,230.25l1.39-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M242.34,233.08h0l18.2-6.15-.51-1.43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229.29,409.71l-19.62-5.39-2.46-118.86h-7L197.8,404.32l-19.62,5.39a5.49,5.49,0,0,0-4,5.29h59.17A5.49,5.49,0,0,0,229.29,409.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M229.29,409.71l-19.62-5.39-2.46-118.86h-7L197.8,404.32l-19.62,5.39a5.49,5.49,0,0,0-4,5.29h59.17A5.49,5.49,0,0,0,229.29,409.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M195.71,415v-3.16a2.92,2.92,0,0,1,1.28-2.42l6.74-4.6V290.15h-2V404.82l-9.86,4.67a2.93,2.93,0,0,0-1.68,2.65V415Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 136.26,
    y: 288.12,
    width: 150.62,
    height: 4.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 136.26,
    y: 288.12,
    width: 150.62,
    height: 4.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 211.77,
    y: 288.12,
    width: 75.1,
    height: 4.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 127.17,
    y: 284.06,
    width: 168.79,
    height: 4.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 202.69,
    y: 284.06,
    width: 93.27,
    height: 4.06
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M128.23,281h60.32a1.47,1.47,0,0,1,0,2.93H128.23a1.47,1.47,0,1,1,0-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M187.75,283h-25a.7.7,0,0,1-.66-.93l10.07-28.75a2,2,0,0,1,1.86-1.33h25a.7.7,0,0,1,.66.93l-10.07,28.75A2,2,0,0,1,187.75,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M188.64,283h-25a.7.7,0,0,1-.65-.93l10.06-28.75a2,2,0,0,1,1.87-1.33h25a.71.71,0,0,1,.66.93L190.5,281.68A2,2,0,0,1,188.64,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M188.64,283h-25a.7.7,0,0,1-.65-.93l10.06-28.75a2,2,0,0,1,1.87-1.33h25a.71.71,0,0,1,.66.93L190.5,281.68A2,2,0,0,1,188.64,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M160.42,283.9a1.47,1.47,0,1,0,0-2.93H128.23a1.47,1.47,0,1,0,0,2.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 205.31,
    cy: 144.09,
    r: 52.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M231.39,106.85v46.32h0v26.58l-52.13.26V106.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M227.18,111.18v42h0v24.12l-44.09.23V111.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M204.54,128.73l-.11,0a7.31,7.31,0,0,1-5.12-7v-3.9a.38.38,0,0,1,.38-.38,3,3,0,0,0,2.63-1.58.37.37,0,0,1,.34-.21h3.77a.39.39,0,0,1,.34.21,3,3,0,0,0,2.62,1.58.39.39,0,0,1,.39.38v3.9a7.35,7.35,0,0,1-5.12,7l-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M209.39,117.44a3,3,0,0,1-2.62-1.58.39.39,0,0,0-.34-.21h-1.89v13.08l.12,0a7.35,7.35,0,0,0,5.12-7v-3.9a.39.39,0,0,0-.39-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M204.54,127.1a.4.4,0,0,1-.15,0,5.77,5.77,0,0,1-3.55-5.35v-2.61a.39.39,0,0,1,.26-.36,4.47,4.47,0,0,0,2.07-1.42.42.42,0,0,1,.3-.15h2.14a.38.38,0,0,1,.3.15,4.52,4.52,0,0,0,2.07,1.42.38.38,0,0,1,.26.36v2.61a5.77,5.77,0,0,1-3.55,5.35.4.4,0,0,1-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M208,118.75a4.52,4.52,0,0,1-2.07-1.42.38.38,0,0,0-.3-.15h-1.07v9.92a.4.4,0,0,0,.15,0,5.77,5.77,0,0,0,3.55-5.35v-2.61a.38.38,0,0,0-.26-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M204,123.74a.39.39,0,0,1-.27-.11l-1.2-1.19a.38.38,0,0,1,0-.54.39.39,0,0,1,.55,0l.92.92,2.11-2.12a.38.38,0,0,1,.54,0,.39.39,0,0,1,0,.55l-2.38,2.38a.43.43,0,0,1-.27.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M206.06,120.7l-1.52,1.52v1.08l2.06-2a.39.39,0,0,0,0-.55A.38.38,0,0,0,206.06,120.7Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-46",
    transform: "translate(187.47 136.27)"
  }, "INSURANCE POLICY"), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M220.56,141H187.9c-.16,0-.29-.07-.29-.17s.13-.17.29-.17h32.66c.15,0,.28.08.28.17S220.71,141,220.56,141Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M220.56,143.52H187.9c-.16,0-.29-.08-.29-.17s.13-.18.29-.18h32.66c.15,0,.28.08.28.18S220.71,143.52,220.56,143.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M220.56,146H187.9c-.16,0-.29-.08-.29-.18s.13-.18.29-.18h32.66c.15,0,.28.08.28.18S220.71,146,220.56,146Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 188.15,
    y: 150.12,
    width: 4.34,
    height: 4.34,
    rx: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 188.18,
    y: 157.59,
    width: 4.34,
    height: 4.34,
    rx: 1.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M189.19,165h2.32a1,1,0,0,1,1,1v2.44a.9.9,0,0,1-.9.9h-2.44a1,1,0,0,1-1-1v-2.32a1,1,0,0,1,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M204.4,172.76H188.51a.16.16,0,0,1-.14-.18.16.16,0,0,1,.14-.17H204.4a.16.16,0,0,1,.14.17A.16.16,0,0,1,204.4,172.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M199.18,174.9H188.46c-.05,0-.09-.08-.09-.17s0-.17.09-.17h10.72c.06,0,.1.07.1.17S199.24,174.9,199.18,174.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M190.32,153.22a.43.43,0,0,1-.27-.11l-1.19-1.19a.38.38,0,1,1,.54-.54l.92.92,2.12-4a.38.38,0,0,1,.54,0,.39.39,0,0,1,0,.55l-2.39,4.23a.39.39,0,0,1-.27.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M190.35,160.68a.4.4,0,0,1-.27-.11l-1.19-1.19a.38.38,0,0,1,.54-.54l.92.92,2.11-3.69a.39.39,0,0,1,.55,0,.38.38,0,0,1,0,.54l-2.39,4a.39.39,0,0,1-.27.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M190.35,168.14a.35.35,0,0,1-.27-.13l-1.19-1.37a.5.5,0,0,1,0-.63.35.35,0,0,1,.54,0l.92,1.06,2.11-3.51a.36.36,0,0,1,.55,0,.5.5,0,0,1,0,.63L190.62,168a.34.34,0,0,1-.27.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M217.54,151.18H195.65a.18.18,0,0,1-.19-.17.19.19,0,0,1,.19-.17h21.89a.19.19,0,0,1,.2.17A.18.18,0,0,1,217.54,151.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M216.53,153.68H195.64a.17.17,0,0,1-.18-.17.18.18,0,0,1,.18-.17h20.89a.18.18,0,0,1,.18.17A.17.17,0,0,1,216.53,153.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M217.54,158.69H195.65a.19.19,0,0,1-.19-.17.18.18,0,0,1,.19-.17h21.89a.18.18,0,0,1,.2.17A.19.19,0,0,1,217.54,158.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M216.53,161.19H195.64a.17.17,0,1,1,0-.34h20.89a.17.17,0,1,1,0,.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M217.35,165.54H195.46a.18.18,0,0,1-.19-.17.17.17,0,0,1,.19-.17h21.89a.17.17,0,0,1,.19.17A.18.18,0,0,1,217.35,165.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M216.34,168H195.45a.17.17,0,0,1-.18-.17.18.18,0,0,1,.18-.17h20.89a.18.18,0,0,1,.18.17A.17.17,0,0,1,216.34,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M213.57,173c-4.28.42-.85,2.31-.85,2.31s3.86-7,3.73-4.1-1.2,3.41-1.2,3.41,1.43-4.12,2.71-1.72,3.61.44,3.61.44"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTxnRequestProcessing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Txn_Request_Processing.6c2b4716.svg";
export { ForwardRef as ReactComponent };